<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section v-menu-permission="'list'" class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter ref="emListFilter" :entity="modelName"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesInventoryDeliveryMaterialResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" aria-labelledby="headingTwo" class="collapse show"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table ref="emTable"
                        :entity="modelName" :importEnabled=true
                        :inlineActionsDisabled="prop_inline!=='1'"
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow">
                <template #left-header>
                  <em-button :busy="onComplete" :disabled="actionDisabled('select')" :showName="true"
                             class="btn-size"
                             confirm-text="确认已清点？"
                             custom-icon="fa fa-fw fa-lg fa-check"
                             custom-label="手动清点"
                             type="save"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="count()"
                  >
                  </em-button>
                  <em-button :disabled="actionDisabled('select')" class="btn-size" custom-icon="fa fa-fw fa-lg fa-box"
                             custom-label="装箱"
                             type="edit"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="openPackageDialog()"
                  ></em-button>
                  <em-button :disabled="actionDisabled('select')" class="btn-size" custom-icon="fa fa-fw fa-lg fa-print"
                             custom-label="打印物料码"
                             type="edit"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="printMaterial()"
                  >
                  </em-button>
                  <em-button :disabled="actionDisabled('selectOne')" :showName="true" class="btn-size"
                             custom-icon="fa fa-fw fa-lg fa-divide"
                             custom-label="拆解物料"
                             type="edit"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="openDivideDialog()"
                  >
                  </em-button>
                  <em-button :disabled="false" :showName="true" class="btn-size"
                             custom-icon="fa fa-fw fa-lg fa-check"
                             custom-label="扫码清点"
                             type="edit"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="openCountDialog()"
                  >
                  </em-button>
                  <em-button :busy="updatingChDesc" :disabled="actionDisabled('select')" :showName="true"
                             class="btn-size"
                             confirm-text="将使用物料基础数据的中文描述覆盖现有内容，请确认"
                             custom-icon="fa fa-fw fa-lg fa-check"
                             custom-label="更新中文描述"
                             type="edit"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="updateMaterialDesc()"
                  >
                  </em-button>
                  <em-button :busy="updatingEnDesc" :disabled="actionDisabled('select')" :showName="true"
                             class="btn-size"
                             confirm-text="将使用物料基础数据的英文描述覆盖现有内容，请确认"
                             custom-icon="fa fa-fw fa-lg fa-check"
                             custom-label="获取英文描述"
                             type="edit"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             @click="updateDeliveryDesc()"
                  >
                  </em-button>
                  <em-button :busy="onDnPosting" :disabled="actionDisabled('select')"
                             :showName="true"
                             class="btn-size"
                             confirm-text="确认过账？"
                             custom-label="DN物料过账"
                             type="search"
                             v-bind:class="'btn btn-success btn-sm'"
                             @click="executeDnPost()"
                  >
                  </em-button>
                  <b-button
                      :disabled="actionDisabled('select')"
                      class="btn-size"
                      size="sm"
                      variant="outline-primary"
                      @click="openUpdateState()"
                  >
                    批量更改状态
                  </b-button>
                  <b-button :disabled="actionDisabled('select')"
                            class="btn-size"
                            size="sm"
                            v-bind:class="'btn btn-outline-primary btn-sm'"
                            variant="outline-primary"
                            @click="openUpdatePackageLoc()"
                  >
                    批量更改物料存储区
                  </b-button>
                  <b-button :disabled="actionDisabled('select')"
                            class="btn-size"
                            size="sm"
                            v-bind:class="'btn btn-outline-primary btn-sm'"
                            variant="outline-primary"
                            @click="openUpdateMaterialCountAssignedWorker()"
                  >
                    批量指派清点员
                  </b-button>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="packageDialogVisible" title="装箱"
               @close='clearPackageForm'>
      <el-table ref="packingTable" :data="showItems" max-height="285px" style="width:100%">
        <el-table-column fixed label="品名" prop="deliveryDescription"></el-table-column>
        <el-table-column label="物料号" prop="materialCode"></el-table-column>
        <el-table-column label="单位" prop="unit"></el-table-column>
        <el-table-column label="转交数量" prop="quantity"></el-table-column>
        <el-table-column label="已包装数量" prop="packagedQuantity"></el-table-column>
        <el-table-column label="本次包装">
          <template slot-scope="scope">
            <el-input v-model="scope.row.packageQuantity" clearable size="small"></el-input>
          </template>
        </el-table-column>
      </el-table>

      <el-form ref="packageForm" :model="packageForm" label-width="auto" size="mini" style="margin-top:30px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="长">
              <el-input v-model="packageForm.length"><i slot="suffix" style="font-style:normal">mm</i>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="宽">
              <el-input v-model="packageForm.width"><i slot="suffix" style="font-style:normal">mm</i>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="高">
              <el-input v-model="packageForm.height"><i slot="suffix" style="font-style:normal">mm</i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="净重">
              <el-input v-model="packageForm.netWeight"><i slot="suffix" style="font-style:normal">kg</i>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="毛重">
              <el-input v-model="packageForm.roughWeight"><i slot="suffix"
                                                             style="font-style:normal">kg</i></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="包装箱来源">
              <el-select v-model="packageForm.boxSource">
                <el-option v-for="item in sourceOptions" :key="item.value" :label="item.label"
                           :value="item.value">

                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="包装箱类型">
          <el-select v-model="packageForm.packageType">
            <el-option v-for="type in packageTypeOptions" :key="type.value" :label="type.label"
                       :value="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="底托木支撑规格">
          <el-input v-model="packageForm.bottomJoistDesc"></el-input>
        </el-form-item>
        <el-form-item label="包装内容描述">
          <el-input v-model="packageForm.description" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="packageDialogVisible = false">取 消</el-button>
        <el-button :disabled="checkPackageForm" type="primary" @click="createPackage()">确认包装</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="divideDialogVisible" title="拆解物料" width="30%"
               @close='cleanDivideNumber'>
      <el-form ref="divideForm" :model="divideForm" label-width="auto" size="mini">
        <el-form-item label="拆解份数">
          <el-input-number v-model="divideForm.divideNumber" :min="2"></el-input-number>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="divideDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="divideMaterial()">确认拆解</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog title="扫一扫" :center="true" :visible.sync="innerScannerVisible" @close="closeScannerDialog" :close-on-click-modal="false">
        <qr-code-scanner ref="scanner" @getCodeData="getCodeData"></qr-code-scanner>
    </el-dialog> -->
    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="countDialogVisible" title="扫码清点" width="50%"
               @close='clearMaterialList'>
      <el-table :data="materialList" empty-text="请点击打开扫码框扫码" max-height="285px" style="width:100%">
        <el-table-column label="品名" prop="deliveryDescription" width="200"></el-table-column>
        <el-table-column label="物料号" prop="materialCode" width="200"></el-table-column>
        <el-table-column label="单位" prop="unit" width="50"></el-table-column>
        <el-table-column label="数量" prop="quantity" width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity" clearable></el-input>
          </template>
        </el-table-column>
      </el-table>

        <el-dialog :center="true" :close-on-click-modal='false' append-to-body :visible.sync="openScanner"
                 title="扫一扫" @close="closeScannerDialog">
        <qr-code-scanner ref="countScanner" @getCodeData='getCodeData'>
        </qr-code-scanner>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="countDialogVisible = false">取 消</el-button>
        <el-button @click="openScannerDialog()">打开扫码框</el-button>
        <el-button :disabled="materialList.length == 0" type="primary" @click="countByScan()">确认清点
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateStateVisible" title="批量更改物料状态"
               width="30%" @close='clearUpdateState'>
      <el-form ref="updateStateForm" :model="updateStateForm" :rules="updateStateRules" label-width="auto">
        <el-form-item label="状态" prop="materialState">
          <el-select v-model="updateStateForm.materialState" placeholder="请选择">
            <el-option
                v-for="materialState in materialStateOptions"
                :key="materialState.value"
                :label="materialState.label"
                :value="materialState.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateStateVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateState()">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updatePackageLocVisible" title="批量更改物料存储区"
               width="30%" z-index="1004" @close='clearUpdatePackageLoc'>
      <el-form ref="updatePackageLocForm" :model="updatePackageLocForm" :rules="updatePackageLocRules"
               label-width="auto">
        <b-form-input
            id="packageLocSelector"
            v-model="updatePackageLocForm.packageLocId"
            class="form-control col-2 package-location "
            placeholder="请选择存储区"
            plaintext
            type="text"
            @click="$refs.packageLocSelector.showModal()"
        ></b-form-input>
        <b-table ref="selectableTable" :fields="this.detailFields" :items="this.locationList" :select-mode='selectMode'
                 max-height="285px"
                 selectable
                 style="width:100%"
                 @row-selected="onRowSelected">
        </b-table>
      </el-form>
        <el-dialog :center="true" :close-on-click-modal='false' append-to-body :visible.sync="openPackageLocScanner"
                 title="扫一扫" z-index="1005" @close="closePackageLocScannerDialog">
        <qr-code-scanner ref="packageLocScanner" @getCodeData='getPackageData'>
        </qr-code-scanner>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="openPackageLocScannerDialog">打开扫码框</el-button>
        <el-button @click="updatePackageLocVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdatePackageLoc()">确认</el-button>
      </div>
      <em-modal-normal-input-entity-selector ref="packageLocSelector" entity="sithMesMstLocation"
                                             @entityModalSelectSelected="updateValue">
      </em-modal-normal-input-entity-selector>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateMaterialCountAssignedWorkerVisible" title="批量指派清点员"
               width="30%" z-index="1004" @close='clearUpdateMaterialCountAssignedWorker'>
      <el-form ref="updateMaterialCountAssignedWorkerForm" :model="updateMaterialCountAssignedWorkerForm"
               :rules="updateMaterialCountAssignedWorkerRules"
               label-width="auto">
        <b-form-input
            id="userSelector"
            v-model="updateMaterialCountAssignedWorkerForm.loginName"
            class="form-control col-2 package-location "
            placeholder="请选择人员"
            plaintext
            type="text"
            @click="$refs.userSelector.showModal()"
        ></b-form-input>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateMaterialCountAssignedWorkerVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateMatCountAssignedWorker()">确认</el-button>
      </div>
      <em-modal-normal-input-entity-selector ref="userSelector" entity="emAclUser"
                                             @entityModalSelectSelected="updateUser">
      </em-modal-normal-input-entity-selector>
    </el-dialog>
  </div>
</template>
<script>
// Author Lin
// Date 2021-05-25 10:29:43

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";
import EmModalNormalInputEntitySelector from "@/components/em/EmModal/NormalInputEntitySelector";

export default {
  name: "sithMesInventoryDeliveryMaterialListView",
  components: {qrCodeScanner, EmModalNormalInputEntitySelector},
  mixins: [emCommonListMixin, emCommonApiMixin],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    },

  },
  data() {
    return {
      onDnPosting: false,
      packageDialogVisible: false,
      packageForm: {
        length: '',
        width: '',
        height: '',
        netWeight: '',
        roughWeight: '',
        boxSource: '',
        packageType: '',
        description: '',
        bottomJoistDesc: '',
      },
      locationList: [],
      selectMode: 'single',
      detailFields: [],
      showItems: [],
      sourceOptions: [{
        value: '1', label: '新制'
      }, {
        value: '2', label: '旧箱'
      }, {
        value: '3', label: '改造'
      }, {
        value: '4', label: '裸装'
      }
      ],
      onComplete: false,
      // 拆解对话框是否显示
      divideDialogVisible: false,
      divideForm: {
        divideNumber: 2
      },
      // 包装箱类型，后端有对应PackageTypeEnum
      packageTypeOptions: [{
        value: '1', label: '内箱'
      }, {
        value: '2', label: '外箱'
      }],
      // 扫码清点对话框是否显示
      innerScannerVisible: false,
      countDialogVisible: false,
      materialList: [],
      openScanner: false,
      openPackageLocScanner: false,
      updatingChDesc: false,
      updatingEnDesc: false,

      //物料状态，后端对应DeliveryMaterialStatusEnum
      materialStateOptions: [
        {value: '1', label: '待清点'},
        {value: '2', label: '待包装'},
        {value: '3', label: '已装箱'},
      ],
      updateStateVisible: false,
      updatePackageLocVisible: false,
      updateMaterialCountAssignedWorkerVisible: false,
      updateStateForm: {
        materialState: ''
      },
      updateStateRules: {materialState: [{required: true, message: '请选择物料状态！'}]},
      updatePackageLocForm: {
        packageLocId: ''
      },
      updatePackageLocRules: {packageLocId: [{required: true, message: '请选择物料存储区'}]},
      updateMaterialCountAssignedWorkerForm: {
        loginName: ''
      },
      updateMaterialCountAssignedWorkerRules: {loginName: [{required: true, message: '请选择指派的人'}]},
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    checkedItems() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItems"];
    },
    selectIds() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItems"].join(",");
    },
    choosenItems() {
      let self = this;
      let choosenArry = this.$store.state[this.modelName]["rows"].filter(function (x) {
        return self.checkedItems.indexOf(x.id) > -1;
      });
      return choosenArry;
    },
    checkPackageForm() {
      let obj = this.packageForm;
      for (const key in obj) {
        if (obj[key] === null || obj[key] === '') {
          return true;
        }
      }
      return false;
    },
    entityBaseUrl() {
      return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
    },
  },
  methods: {
    onRowSelected(items) {
      if (items.length === 0) {
        return;
      }
      this.updatePackageLocForm.packageLocId = items[0].id;
    },
    updateValue(selectRow) {
      console.log(selectRow)
      this.updatePackageLocForm.packageLocId = selectRow.id;
    },
    updateUser(selectRow) {
      console.log(selectRow)
      this.updateMaterialCountAssignedWorkerForm.loginName = selectRow.loginName;
    },
    actionDisabled(type) {
      // 删除按钮在一条记录都没选的时候禁用
      if (type === "select") {
        return this.checkedItems && this.checkedItems.length === 0;
      }
      // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
      else if (type === "selectOne") {
        return this.checkedItems && this.checkedItems.length !== 1;
      }
    },
    count() {
      this.onComplete = true;
      let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/count?ids=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            commonViewsUtil.showSuccess(this, "清点完成");
            this.$refs.emListFilter.doQuery()
          })
          .finally(() => this.onComplete = false)
    },
    openPackageDialog() {
      let itemArr = JSON.parse(JSON.stringify(this.choosenItems));
      this.showItems = itemArr.map(row => {
        //如果已包装数量为空，设置本次包装数为全部转交数量
        if (typeof (row.packagedQuantity) == "undefined") {
          row.packagedQuantity = 0;
          return Object.assign(row, {packageQuantity: row.quantity})
        } else {
          return Object.assign(row, {packageQuantity: row.quantity - row.packagedQuantity})
        }

      });
      console.log("selected===" + JSON.stringify(this.showItems));
      this.packageDialogVisible = true;
    },
    clearPackageForm() {
      this.packageForm.length = '';
      this.packageForm.width = '';
      this.packageForm.height = '';
      this.packageForm.netWeight = '';
      this.packageForm.roughWeight = '';
      this.packageForm.boxSource = '';
      this.packageForm.description = '';
      this.packageForm.bottomJoistDesc = '';
    },
    print() {
      let url = `${this.entityBaseUrl}print?ids=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            this.$router.push({
              name: "sithMesInventoryItemPrint",
              query: response.data,
            });
          })
    },
    printMaterial() {
      let url = `${this.entityBaseUrl}printMaterial?ids=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            this.$router.push({
              name: "sithMesInventoryDeliveryMaterialPrint",
              query: response.data,
            });
          })
    },

    createPackage() {
      let self = this;
      let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryPackage")}/createPackage`;
      let requestBody = {};
      let ids = self.selectIds;
      requestBody.idStr = ids;
      requestBody.length = self.packageForm.length;
      requestBody.height = self.packageForm.height;
      requestBody.width = self.packageForm.width;
      requestBody.netWeight = self.packageForm.netWeight;
      requestBody.roughWeight = self.packageForm.roughWeight;
      requestBody.boxSource = self.packageForm.boxSource;
      requestBody.packageType = self.packageForm.packageType;
      requestBody.bottomJoistDesc = self.packageForm.bottomJoistDesc;
      requestBody.description = self.packageForm.description;
      requestBody.selectedMat = self.showItems;
      self.$_emApiMixin_post(url, requestBody)
          .then((request) => {
            if (request.status === 200) {
              self.$message({
                message: "创建包装任务完成",
                type: "success",
              });

              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "创建包装任务失败",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.packageDialogVisible = false;
          });
    },
    openDivideDialog() {
      this.divideDialogVisible = true;
    },
    // 拆解对话框关闭时将拆解份数恢复默认值2
    cleanDivideNumber() {
      this.divideForm.divideNumber = 2;
    },
    divideMaterial() {
      let self = this;
      let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/divideMaterial?id=${this.checkedItems}&divideNumber=${this.divideForm.divideNumber}`;
      self.$_emApiMixin_post(url, {})
          .then((response) => {
            if (response.status === 200) {
              self.$message({
                message: "拆解完成",
                type: "success",
              });

              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "拆解失败",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.divideDialogVisible = false;
          });
    },
    closeScannerDialog() {
      this.$refs.countScanner.closeCamera();
      this.$refs.countScanner.resetOutputData();
      this.openScanner = false;
    },
    openScannerDialog() {
      this.openScanner = true;
      setTimeout(() => {
        this.$refs.countScanner.openCamera('');
      }, 500);
    },
    closePackageLocScannerDialog() {
      this.$refs.packageLocScanner.closeCamera();
      this.$refs.packageLocScanner.resetOutputData();
      this.openPackageLocScanner = false;
    },
    openPackageLocScannerDialog() {
      this.openPackageLocScanner = true;
      setTimeout(() => {
        this.$refs.packageLocScanner.openCamera('');
      }, 500);
    },
    clearMaterialList() {
      this.materialList = [];
    },
    openCountDialog() {
      this.countDialogVisible = true;
    },
    getCodeData(data) {
      console.log("get qr code data:" + data);
      this.openScanner = false;
      let self = this;
      //检验二维码的数据格式
      try {
        var obj = JSON.parse(data);
        // var materialCode = obj['物料号'];
        var deliveryCode = obj['发货码'];
      } catch (error) {
        self.$message({
          message: "无效的二维码",
          type: "error",
        });
        return;
      }

      if (deliveryCode === '') {
        self.$message({
          message: "二维码中缺少发货码",
          type: "error",
        });
        self.openScanner = false;
        return;
      }

      // var taskId = self.$refs["emListFilter"].$_emCustomVuexMixin_filterStore.deliveryTaskIdFilter;
      // if(!taskId) {
      //     self.$message({
      //     message: "请先选择转交任务ID",
      //     type: "error",
      //     });
      //     self.innerScannerVisible = false;
      //     return;
      // }

      let _url = `${self.$_emApiMixin_entityBaseApi("sithMesInventoryDeliveryMaterial")}/`;
      _url += `findMaterialByDeliveryCode?deliveryCode=${deliveryCode}`;
      self.$_emApiMixin_get(_url, {})
          .then((value) => {
            var arr = Object.keys(value);
            if (arr.length != 0) {
              console.log("value======" + JSON.stringify(value));
              self.materialList = [];
              self.materialList.push(value);
              self.$message({
                message: "扫码成功",
                type: "success",
              });
            } else {
              self.$message({
                message: "无对应物料或物料已清点",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.openScanner = false;
          });
    },
    getPackageData(data) {
      console.log("get qr code data:" + data);
      this.openPackageLocScanner = false;
      this.updatePackageLocForm.packageLocId = '';
      let self = this;
      let packageLocCode = '';
      //检验二维码的数据格式
      try {
        var obj = JSON.parse(data);
        packageLocCode = obj['Storage Bin'];
      } catch (error) {
        self.$message({
          message: "无效的二维码",
          type: "error",
        });
        return;
      }
      if (packageLocCode === undefined) {
        self.$message({
          message: "二维码中缺少位置信息",
          type: "error",
        });
      } else {
        //前端展示table中文名
        this.detailFields = [{key: "code", label: "编码", sortable: false},
          {key: "parentName", label: "上级名称", sortable: false},
          {key: "name", label: "名称", sortable: false},
          {key: "standWorkHour", label: "标准工时", sortable: false}];
        self.$_emApiMixin_findByFilter("sithMesMstLocation", {nameFilter: packageLocCode})
            .then((value) => {
              const arr = Object.values(value);
              if (arr.length !== 0) {
                if (arr.length === 1) {
                  //查出来只有一个，默认
                  self.updatePackageLocForm.packageLocId = arr[0]['id'];
                  this.locationList = value;
                } else {
                  //查出来好多，让他自己选
                  this.locationList = value;
                }
                self.$message({
                  message: "扫码成功",
                  type: "success",
                });
              } else {
                self.$message({
                  message: "地标码无对应恭维信息",
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.openPackageLocScanner = false;
            });
      }
    },
    countByScan() {
      let self = this;
      let url = `${self.$_emApiMixin_entityBaseApi("sithMesInventoryDeliveryMaterial")}/countDeliveryMaterial`;
      self.$_emApiMixin_post(url, self.materialList[0])
          .then((response) => {
            if (response.status === 200) {
              self.$message({
                message: "清点成功！",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "清点失败！",
                type: "error",
              });
            }
          })
          .finally(() => {
            this.countDialogVisible = false;
          });
    },
    updateMaterialDesc() {
      this.updatingChDesc = true;
      let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/updateMaterialDesc?ids=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            if (response.status === 200) {
              commonViewsUtil.showSuccess(this, "更新完成");
              this.$refs.emListFilter.doQuery()
            } else {
              commonViewsUtil.showWarning(this, "更新失败");
            }
          })
          .finally(() => this.updatingChDesc = false)
    },
    updateDeliveryDesc() {
      this.updatingEnDesc = true;
      let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/updateDeliveryDesc?ids=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            if (response.status === 200) {
              commonViewsUtil.showSuccess(this, "更新完成");
              this.$refs.emListFilter.doQuery()
            } else {
              commonViewsUtil.showWarning(this, "更新失败");
            }
          })
          .finally(() => this.updatingEnDesc = false)
    },
    executeDnPost() {
      this.onDnPosting = true;
      let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/executeDnPost?ids=${this.selectIds}`
      this.$_emApiMixin_post(url, {})
          .then(response => {
            if (response.status === 200) {
              commonViewsUtil.showSuccess(this, "SAP过账完成");
              this.$refs.emListFilter.doQuery()
            } else {
              commonViewsUtil.showWarning(this, "SAP过账失败");
            }
          })
          .finally(() => this.onDnPosting = false)
    },
    openUpdateState() {
      this.updateStateVisible = true;
    },
    clearUpdateState() {
      this.updateStateForm.materialState = ''
    },
    openUpdatePackageLoc() {
      this.updatePackageLocVisible = true;
    },
    clearUpdatePackageLoc() {
      this.updatePackageLocForm.packageLocId = '';
      this.locationList = [];
    },
    openUpdateMaterialCountAssignedWorker() {
      this.updateMaterialCountAssignedWorkerVisible = true;
    },
    clearUpdateMaterialCountAssignedWorker() {
      this.updateMaterialCountAssignedWorkerForm.loginName = ''
    },
    batchUpdateState() {
      let self = this;
      this.$refs["updateStateForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateState?ids=${this.selectIds}&materialState=${self.updateStateForm.materialState}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "更新成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "更新失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateStateVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },
    batchUpdatePackageLoc() {
      let self = this;
      this.$refs["updatePackageLocForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdatePackageLoc?ids=${this.selectIds}&packageLocId=${self.updatePackageLocForm.packageLocId}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "更新成功",
                    type: "success",
                  });
                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "更新失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updatePackageLocVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },
    batchUpdateMatCountAssignedWorker() {
      let self = this;
      this.$refs["updateMaterialCountAssignedWorkerForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateMatCountAssignedWorker?ids=${this.selectIds}&materialCountAssignedWorkerLoginName=${self.updateMaterialCountAssignedWorkerForm.loginName}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "更新成功",
                    type: "success",
                  });
                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "更新失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateMaterialCountAssignedWorkerVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },
  }
};
</script>
<style scoped>
.btn-size {
  font-size: 0.60rem;
}

.package-location {
  z-index: 100;
}
</style>
